import { _gsScope } from 'gsap/all';
import * as PIXI from 'pixi.js';

_gsScope.PIXI = PIXI;

export default function Cloud(appearance, _options = {}) {
  PIXI.Sprite.call(this);

  this.options = { ..._options };
  this.time = 40;
  this.progress = this.options.id / this.options.cloudMax;
  this.cloud = new PIXI.Sprite(appearance);
  this.cloud.anchor.set(0.5);
  this.cloud.alpha = 0;
  this.cloud.blendMode = PIXI.BLEND_MODES.SOFT_LIGHT;

  this.addChild(this.cloud);
  this.scaleMin = this.options.model.scale * 0.3;
  this.scaleMax = this.scaleMin + 1;
  this.cloud.scale.x = this.cloud.scale.y = this.scaleMin;
  this.cloud.alpha = 0;
  this.cloud.x = this.options.model.x0;

  this.cloud.y = this.options.model.y;
  this.options.container.addChildAt(this, 0);

  const tl = new TimelineMax({ repeat: -1 });
  tl.to(this.cloud, 3, { alpha: 1, ease: Sine.easeIn }, 'run');
  tl.to(this.cloud, this.time, { pixi: { scaleX: this.scaleMax, scaleY: this.scaleMax }, x: this.options.model.x1, y: '+=' + 250, ease: ExpoScaleEase.config(this.scaleMin, this.scaleMax) }, 'run');
  tl.to(this.cloud, 5, { alpha: 0, onComplete: this.setBehind.bind(this) }, '-=5');
  tl.progress(1 - this.progress);
  tl.timeScale(0.7);
}

Cloud.constructor = Cloud;
Cloud.prototype = Object.create(PIXI.Sprite.prototype);

Cloud.prototype.setBehind = function () {
  this.options.container.addChildAt(this, 0);
};



// WEBPACK FOOTER //
// ./src/js/backgroundClouds/Cloud.js